import React, { Component } from "react";

export default class Welcome extends Component {
  render() {
    return (
      <div className="pt-5">
        <div className="container">
          <h4 className="text-center">
            Welcome back! Here's what you can do today
          </h4>
          <div className="row my-5">
            <div className="col-md-6 mb-4">
              <div className="card card-selector shadow-sm">
                <div className="row p-4">
                  <div className="col-md-3">
                    <img
                      src="./images/welcome/draw.png"
                      style={{ width: "100%" }}
                      alt=""
                    />
                  </div>
                  <div className="col-md-9 d-flex align-items-center">
                    <h5>Jump right in and create a course</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 mb-4">
              <div className="card card-selector shadow-sm">
                <div className="row p-4">
                  <div className="col-md-3">
                    <img
                      src="./images/welcome/browser.png"
                      style={{ width: "100%" }}
                      alt=""
                    />
                  </div>
                  <div className="col-md-9 d-flex align-items-center">
                    <h5>Learn how TalentLMS works by taking a sample course</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card card-selector shadow-sm">
                <div className="row p-4">
                  <div className="col-md-3">
                    <img
                      src="./images/welcome/feedback.png"
                      style={{ width: "100%" }}
                      alt=""
                    />
                  </div>
                  <div className="col-md-9 d-flex align-items-center">
                    <h5>
                      Customize your account by adding your logo, changing the
                      language, themes and colors
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card card-selector shadow-sm">
                <div className="row p-4">
                  <div className="col-md-3">
                    <img
                      src="./images/welcome/goal.png"
                      style={{ width: "100%" }}
                      alt=""
                    />
                  </div>
                  <div className="col-md-9 d-flex align-items-center">
                    <h5>
                      Go to the Administrator dashboard and explore all our
                      features Don't show this tour on login
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
